import React from "react";
import { observer } from "mobx-react";
import "./ObOther.scss";

function ObOther(props) {
  return (
    <div className="ob-other component">
      {props.model.fields.map((field) => (
        <div key={field.label} className="field">
          <div className="wrapper">
            <div className="label">{field.label}:</div>
            <div className="value">{field.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
export default observer(ObOther);
